export const primeCouponCode = {
  M06DISCOUNT: "M06DISCOUNT",
  M06DISCOUNT279: "M06DISCOUNT279",
  M03DISCOUNT279: "M03DISCOUNT279",
  M03DISCOUNT279AF2: "M03DISCOUNT279AF2",
  M03DISCOUNT279DC10: "M03DISCOUNT279DC10",
  M03DISCOUNT279DC15: "M03DISCOUNT279DC15",
  M06DISCOUNT279DC14: "M06DISCOUNT279DC14",
  M12DISCOUNT279DC10TDT: "M12DISCOUNT279DC10TDT",
  M12DISCOUNT289DC10TDT: "M12DISCOUNT289DC10TDT",
  daangnDC05: "daangnDC05",
  CHUSEOK: "CHUSEOK",
  M12GIFTACCOUNT: "M12GIFTACCOUNT",
  HBF: "4Kp9mNxQ7L",
  M01DISCOUNT289M1MT: "M01DISCOUNT289M1MT",
  M01DISCOUNT289MS99MT: "M01DISCOUNT289MS99MT",
  M01DISCOUNT289M1MTTDT: "M01DISCOUNT289M1MTTDT",
  M01DISCOUNT289MS99MTTDT: "M01DISCOUNT289MS99MTTDT",
};

export const liveMSCouponCode = primeCouponCode.M03DISCOUNT279;
